import { NgModule } from '@angular/core';
import { NwWatchlistModule, NwWatchlistRouting } from '@nw/ui-watchlist';
import {NwSharedModule} from '@nw/ui-core-shared/shared.module';

@NgModule({
  declarations: [],
  imports     : [
    NwWatchlistModule,
    NwWatchlistRouting
  ],
  providers   : []
})

export class WatchlistProxyModule {
}



// WEBPACK FOOTER //
// ./src/main/angular/app/watchlist/watchlist-proxy.module.ts